// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3RQhc","header":"ClearentDisclaimer_header__tc4bn","inner":"ClearentDisclaimer_inner__Nag4Z"};